const menuList = [
  {
    id: 44,
    idList: [44, 251],
    value: 0,
    backgroundColor: '#6590ff',
    img: require('@/assets/image/default/finance/receivables.png'),
    text: '门店收款',
    path: '/templates/vue-account/dist/index.htm#/customerArrearPerOrder',
    isHidden: true
  },
  {
    id: 46,
    value: 0,
    backgroundColor: '#ff9c65',
    img: require('@/assets/image/default/finance/payment.png'),
    text: '供应商付款',
    path: '/Account/sys/purchasePay/index.html',
    isHidden: true
  },
  {
    id: 48,
    idList: [48, 313],
    value: 1,
    backgroundColor: '#66d6ff',
    img: require('@/assets/image/default/finance/store.png'),
    text: '门店费用',
    path: '/Account/sys/feebill/customerFee/_customerCashFeeForm.html',
    isHidden: true
  },
  {
    id: 50,
    idList: [50, 311],
    value: 0,
    backgroundColor: '#7e65ff',
    img: require('@/assets/image/default/finance/other.png'),
    text: '其他费用',
    path: '/Account/sys/feeBill/otherFeebill/index.html',
    isHidden: true
  }
]

export const getMenuList = (flag) => {
  if (flag) {
    let indexOf44 = menuList.findIndex(i => i.id == 44)
    if (indexOf44 > -1) {
      menuList[indexOf44].id = 251
      menuList[indexOf44].text = '门店收欠款'
      menuList[indexOf44].path = '/yunsierp3/index.html#/payment/collectArrears'
    }
    let indexOf48 = menuList.findIndex(i => i.id == 48)
    if (indexOf48 > -1) {
      menuList[indexOf48].id = 313
      menuList[indexOf48].text = '客户费用'
      menuList[indexOf48].path = '/yunsierp3/index.html#/finance/customerFee'
    }
    let indexOf50 = menuList.findIndex(i => i.id == 50)
    if (indexOf50 > -1) {
      menuList[indexOf50].id = 311
      menuList[indexOf50].text = '其他费用'
      menuList[indexOf50].path = '/yunsierp3/index.html#/finance/otherFee'
    }
    return menuList
  }
  return menuList
}